<template>
    <div class="energy-storage-container">
        <div class="row">
            <div class="col-item">
                <div class="col_title">总统计</div>
                <div class="ztj_row">
                    <div class="ztj_img">
                        <img
                            src="../../../assets/image/leaderpage/ztjback.png"
                        />
                        <div class="leftwnzi">总充电量</div>
                        <div class="rightwnzi">640<i>kWh</i></div>
                    </div>
                    <div class="ztj_img">
                        <img
                            src="../../../assets/image/leaderpage/ztjback.png"
                        />
                        <div class="leftwnzi">总放电量</div>
                        <div class="rightwnzi">340<i>kWh</i></div>
                    </div>
                </div>
                <div class="ztj_row">
                    <div class="ztj_img">
                        <img
                            src="../../../assets/image/leaderpage/ztjback.png"
                        />
                        <div class="leftwnzi">全生产天数</div>
                        <div class="rightwnzi">340<i>kWh</i></div>
                    </div>
                    <div class="ztj_img">
                        <img
                            src="../../../assets/image/leaderpage/ztjback.png"
                        />
                        <div class="leftwnzi">总充放电次数</div>
                        <div class="rightwnzi">340<i>次</i></div>
                    </div>
                </div>
            </div>
            <div class="col-item">
                <div class="col_title">近18个月充放电量</div>
                <v-chart
                    :auto-resize="true"
                    :options="eighteenMonths"
                    ref="eighteenMonths"
                    theme="ovilia-green"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-item">
                <div class="col_title">总SOC</div>
                <div class="item_dianchi">
                    <div>
                        <img
                            src="../../../assets/image/leaderpage/dianchi.png"
                        />
                        <div>运行状态：运行</div>
                    </div>
                    <div>
                        <div class="col_list">
                            <img
                                src="../../../assets/image/leaderpage/l1.png"
                            />&nbsp;总SOC：<span>0.0<i>%</i></span>
                        </div>
                        <div class="col_list">
                            <img
                                src="../../../assets/image/leaderpage/l2.png"
                            />&nbsp;剩余能量：<span>0 <i>kW</i></span>
                        </div>
                        <div class="col_list">
                            <img
                                src="../../../assets/image/leaderpage/l3.png"
                            />&nbsp;总SOH：<span>100<i>%</i></span>
                        </div>
                    </div>
                    <div class="col_pie">
                        <v-chart
                            :auto-resize="true"
                            :options="pieLeft"
                            ref="pieLeft"
                            theme="ovilia-green"
                        />
                    </div>
                </div>
            </div>
            <div class="col-item">
                <div class="col_title">近30天实时日充放电量</div>
                <v-chart
                    :auto-resize="true"
                    :options="thirtyDays"
                    ref="thirtyDays"
                    theme="ovilia-green"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-item">
                <div class="col_title">实时日充放电功率曲线</div>
                <v-chart
                    :auto-resize="true"
                    :options="lineLeft"
                    ref="lineLeft"
                    theme="ovilia-green"
                />
            </div>
            <div class="col-item">
                <div class="col_title">实时日充放电电量</div>
                <v-chart
                    :auto-resize="true"
                    :options="lineRight"
                    ref="lineRight"
                    theme="ovilia-green"
                />
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
export default {
    name: "Main",
    components: {},
    data() {
        return {
            pieInnerFont: 18, //饼状图内部数字字体大小
            pieInnerTtitleFont: 16, //饼状图内部文字字体大小
            legendFont: 12, // 图例文字大小
            timer: ""
        };
    },
    mounted() {
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
        // this.timer = setInterval(this.reloadData, 5000);
    },
    methods: {
        setImgSize() {
            if (window.innerWidth >= 1920) {
                this.pieInnerFont = 27;
                this.pieInnerFontUnit = 15;
                this.pieInnerTtitleFont = 17;
                this.legendFont = 12;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.pieInnerFont = 25;
                this.pieInnerFontUnit = 13;
                this.pieInnerTtitleFont = 15;
                this.legendFont = 12;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.pieInnerFont = 23;
                this.pieInnerFontUnit = 11;
                this.pieInnerTtitleFont = 13;
                this.legendFont = 10;
            } else {
                this.pieInnerFont = 21;
                this.pieInnerFontUnit = 10;
                this.pieInnerTtitleFont = 12;
                this.legendFont = 10;
            }
        }
    },
    computed: {
        eighteenMonths() {
            const option = {
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
               color: ["#1593CE", "#CE720b"],
             
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    orient: "horizontal",
                    icon: "circle",
                    // top: 10,
                    data: [
                        {
                            name: "总充电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "总放电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: [
                            "2019-11",
                            "2019-12",
                            "2020-01",
                            "2020-02",
                            "2020-03",
                            "2020-04",
                            "2020-05",
                            "2020-06",
                            "2020-07",
                            "2020-08",
                            "2020-09",
                            "2020-10",
                            "2020-11"
                        ],
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "电量（kWh）",
                        type: "value",
                        max: 20,
                        nameTextStyle: {
                            color: "#fff",
                            fontSize: this.legendFont
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "总充电量",
                        type: "bar",
                        barGap: 0,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                            }
                        },
                        label: 111,
                        data: [
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16
                        ]
                    },
                    {
                        name: "总放电量",
                        type: "bar",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F5E3B7'
                                }, {
                                    offset: 1,
                                    color: '#CB7A07'
                                }]),
                            }
                        },
                        label: 222,
                        data: [10, 8, 12, 6, 8, 12, 10, 6, 12, 8, 10, 12, 6]
                    }
                ]
            };
            return option;
        },
        thirtyDays() {
            const option = {
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    orient: "horizontal",
                    icon: "circle",
                    // top: 10,
                    data: [
                        {
                            name: "峰时发电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "谷时发电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: [
                            "2019-11",
                            "2019-12",
                            "2020-01",
                            "2020-02",
                            "2020-03",
                            "2020-04",
                            "2020-05",
                            "2020-06",
                            "2020-07",
                            "2020-08",
                            "2020-09",
                            "2020-10",
                            "2020-11"
                        ],
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "电量（kWh）",
                        type: "value",
                        max: 20,
                        nameTextStyle: {
                            color: "#fff",
                            fontSize: this.legendFont
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "峰时发电量",
                        type: "bar",
                        barGap: 0,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                            }
                        },
                        label: 111,
                        data: [
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16,
                            16
                        ]
                    },
                    {
                        name: "谷时发电量",
                        type: "bar",
                        label: 222,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F5E3B7'
                                }, {
                                    offset: 1,
                                    color: '#CB7A07'
                                }]),
                            }
                        },
                        data: [14, 6, 10, 8, 10, 6, 8, 12, 8, 6, 12, 8, 10]
                    }
                ]
            };
            return option;
        },
        lineLeft() {
            const option = {
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                color: ["#CE720b", "#1593CE"],
                legend: {
                    orient: "horizontal",
                    icon: "circle",
                    // top: 10,
                    data: [
                        {
                            name: "总充电电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "总放电电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        data: [
                            "0时",
                            "2时",
                            "4时",
                            "6时",
                            "8时",
                            "10时",
                            "12时",
                            "14时",
                            "16时",
                            "18时",
                            "20时",
                            "22时",
                            "24时"
                        ],
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "电量（kWh）",
                        type: "value",
                        max: 20,
                        nameTextStyle: {
                            color: "#fff",
                            fontSize: this.legendFont
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "总充电电量",
                        type: "line",
                        smooth: true,
                        data: [8, 16, 8, 18, 8, 17, 6, 14, 8, 12, 8, 14, 8]
                    },
                    {
                        name: "总放电电量",
                        type: "line",
                        smooth: true,
                        data: [8, 12, 8, 14, 8, 14, 6, 12, 8, 11, 8, 13, 8]
                    }
                ]
            };
            return option;
        },
        lineRight() {
            const option = {
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                color: ["#CE720b", "#1593CE"],
                legend: {
                    orient: "horizontal",
                    icon: "circle",
                    // top: 10,
                    data: [
                        {
                            name: "总充电电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "总放电电量",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        data: [
                            "0时",
                            "2时",
                            "4时",
                            "6时",
                            "8时",
                            "10时",
                            "12时",
                            "14时",
                            "16时",
                            "18时",
                            "20时",
                            "22时",
                            "24时"
                        ],
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "电量（kWh）",
                        type: "value",
                        max: 20,
                        nameTextStyle: {
                            color: "#fff",
                            fontSize: this.legendFont
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "总充电电量",
                        type: "line",
                        smooth: true,
                        data: [6, 16, 6, 14, 8, 19, 6, 14, 6, 12, 6, 14, 6]
                    },
                    {
                        name: "总放电电量",
                        type: "line",
                        smooth: true,
                        data: [6, 12, 6, 14, 6, 14, 6, 12, 6, 11, 6, 13, 6]
                    }
                ]
            };
            return option;
        },
        pieLeft() {
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    right: 50,
                    top: "center",
                    height: 70,
                    icon: "circle",
                    data: [
                        {
                            name: "充电",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "放电",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "故障",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "离线",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: "关机",
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                title: {
                    text: "运行状态",
                    left: "21%",
                    top: "50%",
                    textStyle: {
                        color: "#A6AFB8",
                        fontSize: this.pieInnerTtitleFont,
                        align: "center",
                        fontFamily: "Microsoft YaHei"
                    }
                },
                graphic: [
                    {
                        type: "text",
                        left: "26%",
                        top: "40%",
                        style: {
                            text: "储能",
                            textAlign: "center",
                            fill: "#A6AFB8",
                            fontWeight: "bold",
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerTtitleFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    }
                ],
                series: [
                    {
                        name: "储能运行状态",
                        type: "pie",
                        radius: ["55%", "70%"],
                        center: ["30%", "50%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center"
                        },
                        data: [
                            {
                                value: 335,
                                name: "充电",
                                itemStyle: {
                                    color: "#00bbf0"
                                }
                            },
                            {
                                value: 125,
                                name: "放电",
                                itemStyle: {
                                    color: "#28d573"
                                }
                            },
                            {
                                value: 125,
                                name: "故障",
                                itemStyle: {
                                    color: "#ec7474"
                                }
                            },
                            {
                                value: 125,
                                name: "离线",
                                itemStyle: {
                                    color: "#ff9502"
                                }
                            },
                            {
                                value: 30,
                                name: "关机",
                                itemStyle: {
                                    color: "#99a099"
                                }
                            }
                        ]
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.energy-storage-container {
    width: 100%;
    height: 100%;
    padding: 0 2rem 2rem 2rem;
    box-sizing: border-box;
    .row {
        width: 100%;
        height: calc((100% - 4rem) / 3);
        margin-bottom: 2rem;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        &:last-child {
            margin-bottom: 0;
        }
        .col-item {
            width: calc((100% - 2rem) / 2);
            height: 100%;
            margin-right: 2rem;
            .col_title {
                font-size: 0.8rem;
                padding-left: 1.8rem;
                padding-top: 0.4rem;
                color: #fff;
                // text-indent: 1rem;
                height: 1rem;
            }
            .echarts {
                width: 94%;
                margin: 0 3%;
                height: calc(100% - 1rem);
            }
            &:last-child {
                margin-right: 0;
            }
            background: url("../../../assets/image/leaderpage/energy_back.png")
                no-repeat;
            background-size: 100% 100%;
            .ztj_row {
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                margin: 0.5rem 1.5rem 0 1.5rem;
                width: calc(100% - 3rem);
                height: calc((100% - 4rem) / 2);
                &:last-child {
                    margin-bottom: 1rem;
                }
                .ztj_img {
                    width: 45%;
                    // height:100%;
                    //background: url('../../../assets/image/leaderpage/ztjback.png') no-repeat;
                    //  background-size: 100% 100%;
                    margin: 0 auto;
                    color: #fff;
                    text-align: center;
                    position: relative;
                    img {
                        width: 100%;
                        height: auto;
                    }
                    .leftwnzi {
                        position: absolute;
                        top: calc(50% - 0.3rem);
                        left: 30%;
                        font-size: 0.9rem;
                        color: #4bdbe6;
                    }
                    .rightwnzi {
                        position: absolute;
                        top: calc(50% - 0.45rem);
                        left: 70%;
                        font-size: 1.3rem;
                        color: #49deb4;
                        > i {
                            font-size: 0.9rem;
                        }
                    }
                }
            }
            .item_dianchi {
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                text-align: center;
                height: calc(100% - 1rem);
                width: 100%;
                color: #fff;
                > div:first-child {
                    width: 30%;
                }
                > div:last-child {
                    width: 50%;
                    height: 100%;
                }
                > div {
                    > img {
                        width: 8rem;
                        height: auto;
                        margin-bottom: 1rem;
                    }
                }
                .col_list {
                    height: 2rem;
                    line-height: 2rem;
                    font-size: 0.8rem;
                    span i {
                        font-size: 0.5rem;
                        margin-left: 0.2rem;
                    }
                    &:first-child span {
                        color: #57fcfe;
                    }
                    &:nth-child(2) span {
                        color: #51ffc4;
                    }
                    &:last-child span {
                        color: #fac22d;
                    }
                }
            }
        }
    }
}
</style>
